// @flow

const httpRequestMethods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
};

export type HttpRequestMethod = $Keys<typeof httpRequestMethods>;

export default httpRequestMethods;
